import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthGoogleCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const savedState = sessionStorage.getItem("g_oauth_state");
    sessionStorage.removeItem("g_oauth_state");
    const redirectUri = window.location.origin + "/auth/google";

    if (params.get("error") || !code) {
      toast.error("Google sign-in was cancelled.");
      navigate("/login");
      return;
    }
    if (savedState && state && savedState !== state) {
      toast.error("Sign-in session mismatch. Please try again.");
      navigate("/login");
      return;
    }

    api
      .post("/auth/google", { code, redirect_uri: redirectUri })
      .then(({ data }) => {
        const user = setSession(data.access_token, data.user);
        toast.success("Signed in with Google.");
        navigate(user.role === "admin" ? "/admin" : "/dashboard");
      })
      .catch((err) => {
        toast.error(err.response?.data?.detail || "Google sign-in failed. Please try again.");
        navigate("/login");
      });
  }, [navigate, setSession]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center gap-3 text-slate-500" data-testid="auth-google-callback">
      <Loader2 className="h-7 w-7 animate-spin text-blue-600" />
      <p className="text-sm">Signing you in with Google…</p>
    </div>
  );
}
